import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "./PublishingClassDetails.css";

class PublishClassDetails extends Component {
  render() {
    const { classes, data } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Current Session:</b>
            <div>{data.session}</div>
          </ListItem>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Class:</b>
            <div>{data.class}</div>
          </ListItem>
          {data.group && (
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Group:</b>
              <div>{data.group}</div>
            </ListItem>
          )}
        </div>
        <div className={classes.content}>
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Exam Type:</b>
            <div>{data.exam}</div>
          </ListItem>
          {data.faculty && (
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Faculty:</b>
              <div>{data.faculty}</div>
            </ListItem>
          )}
          <ListItem divider>
            <b style={{ flexGrow: 1 }}>Section:</b>
            <div>{data.section}</div>
          </ListItem>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(PublishClassDetails);
